import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import SearchModal from "../Components/Modals/SearchModal";

type Props = NativeStackScreenProps<RootStackParamList, "Search">;

const SearchScreen: React.FC<Props> = ({ navigation }) => {
  return <SearchModal onClose={() => navigation.goBack()} />;
};

export default SearchScreen;
